import * as React from "react"
import {
  SimpleForm,
  TextInput,
  SelectInput,
  BooleanInput,
  ReferenceInput,
  SaveButton,
  DeleteWithConfirmButton,
  useRecordContext
} from "react-admin"
import { Grid, Toolbar, Box } from "@mui/material"

const CategoryToolbar = ({formType}) => {
  const record = useRecordContext();
  return (
    <Toolbar>
      <Box display="flex" justifyContent="space-between" width="100%">
        {/* 儲存按鈕 (始終顯示) */}
        <SaveButton />
        {/*
          條件渲染刪除按鈕：
          1. 只在編輯模式顯示 (formType === "edit")
        */}
        { formType === "edit" && record.name !== "服飾專區" && (
          <DeleteWithConfirmButton
            confirmTitle="確認刪除"
            confirmContent="您確定要刪除此類別嗎？"
          />
        )}
      </Box>
    </Toolbar>
  );
};

const validateForm = values => {
  const errors = {}
  if (!values.name) {
    errors.name = "ra.validation.required"
  }
  if (!values.sorting) {
    errors.sorting = "ra.validation.required"
  }
  return errors
}

const CategoryForm = ({formType}) => {

  const ExcludeSelectInput = () => {
    const record = useRecordContext();
    const isDisabled = record?.children && record.children.length > 0;
  
    return (
      <ReferenceInput source="parentId" 
        reference="categories" 
        filter={{ type: 'product', level: 'top', excludeId: record.id }}
        sort={{ field: 'sorting', order: 'ASC' }}
        defaultValue={record?.parentId}
      >
        <SelectInput optionText="name" label="父類別" emptyText="無" disabled={isDisabled} />
      </ReferenceInput>
    )
  };

  return (
    <SimpleForm
      defaultValues={{
        name: "",
        status: 1,
        description: "",
        sorting: 1
      }}
      validate={validateForm}
      toolbar={<CategoryToolbar formType={formType} />}
    >
      <Grid container width={{ xs: "90%", xl: 800 }} spacing={2}>
          <Grid item xs={12} sm={8}>
            <TextInput autoFocus source="name" label="名稱" isRequired />
          </Grid>
          <Grid item xs={12} sm={4} 
            sx={{
              display: "flex",
              justifyContent: "right"
            }}
          >
            <BooleanInput label="啟用狀態" source="status" />
          </Grid>
          <Grid item xs={12}>
            { formType === "edit" 
              ? <ExcludeSelectInput />
              : <ReferenceInput source="parentId" 
                  reference="categories" 
                  filter={{ type: 'product', level: 'top' }}
                  sort={{ field: 'sorting', order: 'ASC' }}
                >
                  <SelectInput optionText="name" label="父類別" emptyText="無" />
                </ReferenceInput>
            }
          </Grid>
          <Grid item xs={12}>
            <TextInput source="sorting" label="排序編號" isRequired />
          </Grid>
          <Grid item xs={12}>
            <TextInput source="description"
              label="備註" 
              multiline
              rows={4}
            />
          </Grid>
      </Grid>
    </SimpleForm>
  )
}

export default CategoryForm